module.exports = __webpack_public_path__ + "assets/img/download-qrcode-frame-d3c08c2f.png";